import {
  IonHeader,
  IonToolbar,
  IonTitle,
  IonItem,
  IonInput,
  IonContent,
  IonButton,
} from "@ionic/react";
import React from "react";
import { FC, useState } from "react";

function popitup(url: string) {
  window.open(url, "UPI QR", "height=500,width=500");
}

const UPI: FC = () => {
  const [amount, setAmount] = useState<string>();
  const [amountSet, setAmountSet] = useState<boolean>(false);
  const [upi, setUPI] = useState<string>(
    "https://upiqr.in/api/qr/?name=Dr%20Krishna&vpa=9845541663@apl"
  );
  return (
    <>
      <IonHeader>
        <IonToolbar>
          <IonTitle>UPI QR CODE</IonTitle>
        </IonToolbar>
        {!amountSet && (
          <IonItem>
            <IonInput
              clearInput
              pattern={"[a-zA-Z ]*"}
              value={amount}
              required
              type={"text"}
              placeholder="Enter Amount"
              onIonChange={(e) => {
                setAmount(e.detail.value!);
              }}
            ></IonInput>
            <IonButton
              onClick={() => {
                setUPI(upi + `&amount=${amount}`);
                setAmountSet(true);
              }}
            >
              Set Amount
            </IonButton>
          </IonItem>
        )}
      </IonHeader>
      <IonContent>
        <img
          onClick={() => popitup(upi)}
          style={{ filter: "invert(100%)", cursor: "pointer" }}
          src={upi}
          alt="Loading..."
        />
      </IonContent>
    </>
  );
};

export default UPI;
